import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { Home, KeyRound, Trees, Building2, ArrowRight } from "lucide-react";
import { fadeUp, stagger } from "@/lib/motion";
import { useTranslation } from "react-i18next";

const CATS = [
  { key: "buy", icon: Home, color: "bg-[#1E3A8A]/10 text-[#1E3A8A] dark:text-[#7AA0FF]", to: "/buy" },
  { key: "rent", icon: KeyRound, color: "bg-[#10B981]/12 text-[#0E9F6E]", to: "/rent" },
  { key: "land", icon: Trees, color: "bg-[#F59E0B]/12 text-[#D97706]", to: "/land" },
  { key: "commercial", icon: Building2, color: "bg-[#7C3AED]/12 text-[#7C3AED] dark:text-[#A78BFA]", to: "/commercial" },
];

export const Categories = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  return (
    <section className="bg-background py-12 sm:py-16" data-testid="categories-section">
      <div className="abay-container">
      <div className="flex items-end justify-between gap-4">
        <div>
          <h2 className="text-2xl font-bold tracking-tight text-foreground sm:text-3xl">{t("categories.title")}</h2>
          <p className="mt-2 text-sm text-muted-foreground sm:text-base">{t("categories.subtitle")}</p>
        </div>
        <button type="button" onClick={() => navigate("/map-search")} data-testid="categories-view-all"
          className="flex shrink-0 items-center gap-1 text-sm font-semibold text-[#1E3A8A] transition-colors duration-200 hover:text-[#172D6B] dark:text-[#7AA0FF]">
          {t("common.viewAll")} <ArrowRight className="h-4 w-4" />
        </button>
      </div>

      <motion.div
        variants={stagger}
        initial="hidden"
        whileInView="show"
        viewport={{ once: true, margin: "-80px" }}
        className="mt-6 grid grid-cols-2 gap-3 sm:gap-4 lg:grid-cols-4"
      >
        {CATS.map((c) => (
          <motion.button
            key={c.key}
            variants={fadeUp}
            type="button"
            onClick={() => navigate(c.to)}
            data-testid={`category-card-${c.key}`}
            className="tap-press group flex flex-col items-center justify-center gap-2 rounded-2xl border border-border bg-card p-4 text-center shadow-[var(--shadow-sm)] transition-[transform,box-shadow,border-color] duration-200 hover:-translate-y-1 hover:border-[#1E3A8A]/20 hover:shadow-[var(--shadow-md)] sm:p-6"
          >
            <span className={`flex h-12 w-12 items-center justify-center rounded-2xl transition-transform duration-200 group-hover:scale-105 sm:h-14 sm:w-14 ${c.color}`}>
              <c.icon className="h-5 w-5 sm:h-6 sm:w-6" />
            </span>
            <span className="text-sm font-bold text-foreground">{t(`categories.${c.key}Title`)}</span>
            <span className="-mt-1 text-[11px] font-medium text-muted-foreground sm:text-xs">{t(`categories.${c.key}Desc`)}</span>
          </motion.button>
        ))}
      </motion.div>
      </div>
    </section>
  );
};
